import { useEffect } from 'react'
import { useConversation } from './ConversationContext'
import { useFeedback } from './FeedbackContext'
import { useSession } from '@/features/auth/hooks/useSession'
import { resolveWorkspaceId } from '@/lib/workspace-routing'

/**
 * Syncs the active conversation from ConversationContext into the Feedback system
 * so submissions automatically include conversation metadata.
 */
export function FeedbackConversationBridge() {
  const { activeConversation } = useConversation()
  const { setConversationContext } = useFeedback()
  const { selectedContainer } = useSession()
  const workspaceId = resolveWorkspaceId(selectedContainer)

  useEffect(() => {
    if (activeConversation) {
      setConversationContext({
        workspaceId,
        conversationId: activeConversation.id,
        conversationName: activeConversation.name,
      })
    } else {
      setConversationContext(null)
    }

    return () => {
      setConversationContext(null)
    }
  }, [activeConversation, setConversationContext, workspaceId])

  return null
}

export default FeedbackConversationBridge
